import React from "react";

class ErrorBoundary extends React.Component {
  constructor(props) {
    super(props);
    this.state = { error: null };
  }

  static getDerivedStateFromError(error) {
    return { error };
  }

  render() {
    if (this.state.error) {
      return (
        <div className="flex min-h-screen items-center justify-center bg-[#070709] px-6 text-center">
          <div>
            <p className="mono-label text-[#FF3B30]">Something glitched</p>
            <h1 className="mt-4 font-display text-4xl font-black uppercase">Ayan Jafri — Video Editor</h1>
            <button
              data-testid="error-reload-button"
              className="btn-primary mt-8"
              onClick={() => window.location.reload()}
            >
              Reload
            </button>
          </div>
        </div>
      );
    }
    return this.props.children;
  }
}

export default ErrorBoundary;
